import request from '@/utils/request'

export function fetchBill(schoolId, studentId) {
  return request({
    url: `/schools/${schoolId}/students/${studentId}/bill`,
    method: 'get',
    // 缴费状态可能随时变化，避免浏览器或中间缓存返回旧账单。
    params: { _t: Date.now() },
  })
}

export function fetchBillQuery(schoolId, studentId) {
  return request({
    url: `/schools/${schoolId}/students/${studentId}/bill/query`,
    method: 'get',
    hideloading: true,
    params: { _t: Date.now() },
  })
}

export function createOrder(schoolId, studentId, items) {
  return request({
    url: `/schools/${schoolId}/students/${studentId}/order`,
    method: 'post',
    data: {
      items,
    },
  })
}
